// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import configureConfiguratorComponents from './configureConfiguratorComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
import 'fg-frontend/ramjet/liveValidation';

connectWebComponents(configureConfiguratorComponents);
connectWebActions(configureWebActions, ['keyup']);
cookiesPolicy({
  position: 'bottom',
  enableModal: true,
  imgSrc: '/img/cookie-policy/cookie.svg',
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureConfigurator.js